module.exports = __webpack_public_path__ + "img/logo-part2.55a0dc85.svg";